var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-picker"},[_c('div',{staticClass:"color-options"},_vm._l((_vm.colors),function(color){return _c('div',{key:color,staticClass:"color-option",class:{'selected': _vm.value === color},style:({backgroundColor: color}),on:{"click":function($event){return _vm.$emit('input', color)}}})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d6ff154","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/customization/GlobalBPOCore/pages/SignPDF/SignColorPicker.vue
// module id = null
// module chunks = 